import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { IRoutePart, RoutePartsService } from '../../../shared/services/route-parts.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BreadcrumbService } from './breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  routeParts: IRoutePart[];
  routerEventSub: Subscription;
  public pageTitle: string = '';
  // public isEnabled: boolean = true;

  constructor(
    private router: Router,
    private routePartsService: RoutePartsService,
    private activeRoute: ActivatedRoute,
    private location: Location,
    private _breadcrumbService: BreadcrumbService
  ) {
    this.routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
    this.setRouteTitle();

    this.routerEventSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((routeChange) => {

        this.routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
        this.routeParts = this.routeParts.reverse();
        this.setRouteTitle();
      });

    this._breadcrumbService.onTitleChanged.subscribe(t => {
      this.pageTitle = t;
    });
  }

  ngOnInit() { }
  ngOnDestroy() {
    if (this.routerEventSub) {
      this.routerEventSub.unsubscribe();
    }
  }

  private setRouteTitle(): void {
    if (this.routeParts.length === 0 || this.routeParts[this.routeParts.length - 1].dynamicTitle) {
      return;
    }
    this.pageTitle = this.routeParts[this.routeParts.length - 1].title;
  }

  private parseText(part: IRoutePart) {
    if (!part.breadcrumb) {
      return '';
    }
    part.breadcrumb = part.breadcrumb.replace(/{{([^{}]*)}}/g, (a: any, b: any) => {
      const r = part.params![b];
      return typeof r === 'string' ? r : a;
    });
    return part.breadcrumb;
  }

  public onBackClick(): void {
    let part = this.routeParts[this.routeParts.length - 1];
    if (part.backToPrevious) {
      this.location.back();
    }
  }
}
